import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';
import {ValidatonError} from '../resources/GenericResource';
import {FormImage, ImageUpload} from './FileUpload';

import PhoneFieldComponent from '../components/PhoneFieldComponent';

const SettingsGeneralFormModel = t.struct({
    first_name: t.maybe(t.Str),
    last_name: t.maybe(t.Str),
    website: t.maybe(t.Str),
    phone: t.maybe(t.Str),
    profile_picture: t.maybe(FormImage)
});

class FormLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {inputs, value} = this.props;
        return (
            <div className="tab-section">
                <h2 className="tab-section-title">Profile details</h2>
                <div className="section-content media">
                    <div className="left">
                        <h3 className="label-title">Profile picture</h3>
                        <div className="upload-container">
                            <div className="form-control form-control-upload">
                                <div className="form-control-upload-content">
                                </div>
                                {inputs.profile_picture}
                            </div>
                            <p className="recommended-size">Recommended size: 250x250px</p>
                        </div>
                    </div>
                    <div className="form-cols body">
                        <div className="col">
                            <label className="form-control form-control-text">
                                <h3 className="label-title">First name</h3>
                                {inputs.first_name}
                                <span className="error-msg"></span>
                            </label>

                            <label className="form-control form-control-text">
                                <h3 className="label-title">Last name</h3>
                                {inputs.last_name}
                                <span className="error-msg"></span>
                            </label>
                        </div>
                        <div className="col">
                            <label className="form-control form-control-text">
                                <h3 className="label-title">Website</h3>
                                {inputs.website}
                                <span className="error-msg"></span>
                            </label>

                            <label className="form-control form-control-text">
                                <h3 className="label-title">Phone</h3>
                                {inputs.phone}
                                <span className="error-msg"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function phoneInputTemplate(locals){
    return (
        <PhoneFieldComponent {...locals}/>
    );
}

function makeLayout(locals) {
    return <FormLayout {...locals}/>
}

const Form = baseFormFactory(SettingsGeneralFormModel, true, true);

class SettingsGeneralForm extends Form {
    constructor(props) {
        super(props);
        let isValid = true;
        let test = Object.values(props.initialFormData);
        for (var i = 0; i < test.length; i++){
            if (typeof test[i] === 'undefined' || test[i] === ''){
                isValid = false;
                break;
            }
        }

        const value = props.initialFormData;
        this.state = {
            isValid,
            value
        };
    }

    getOptions() {
        const errors = this.props.errors;
        return {
            auto: 'none',

            template: makeLayout,

            fields: {
                first_name: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('first_name') > -1).length ? 'Please enter a first name' : null
                },

                last_name: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('last_name') > -1).length ? 'Please enter a last name' : null
                },

                phone: {
                    type: 'text',
                    hasError: !!errors,
                    template: phoneInputTemplate,
                    error:  errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('phone') > -1).length ? 'Please enter a phone number' : null
                },

                website: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('website') > -1).length ? 'Please enter a website' : null
                },

                profile_picture: {
                    type: 'file',
                    factory: ImageUpload,
                    hasError: !!errors,
                    error: errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('profile_picture') > -1).length ? errors.errors.profile_picture : null
                }
            }
        };
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

SettingsGeneralForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func
};


export default SettingsGeneralForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/SettingsProfileForm.js
 **/